import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { styled, keyframes } from '@mui/system';

// Define the bounce animation
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
`;

// Create a styled InfoIcon component with animation
const BouncingIcon = styled(InfoIcon)`
  font-size: 80px;
  margin-bottom: 16px;
  animation: ${bounce} 2s infinite;
  color: white;
`;

const NoData = ({ text }) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      height='50vh'
      textAlign='center'
    >
      <BouncingIcon />
      <Typography
        variant='h5'
        color='white'
        fontWeight={600}
      >
        {text}
      </Typography>
    </Box>
  );
};

NoData.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NoData;
